import React from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import cn from "classnames";
import styles from "./Create.module.sass";
import { create_role } from "../../../../../../API/RBAC";
import * as Yup from "yup";
import { message } from "antd";
import Card from "../../../../../../components/Card";
import TextInput from "../../../../../../components/TextInput";
import Panel from "../Panel";
import Icon from "../../../../../../components/Icon";

const CreateRole = () => {
  const navigate = useNavigate();
  const initialValues = { name: "" };
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
  });

  const handleSave = async (values, { setSubmitting }) => {
    try {
      const formData = {
        role: values.name,
      };
      const res = await create_role(formData);
      if (res.status === 201) {
        message.success("Role created successfully");
        navigate(`/settingsDashboard/accessControl/roles/${res.data.data.id}`);
      }
    } catch (error) {
      const errors = error.response?.data?.errors;
      if (error.response?.status === 400) {
        message.error(Object.values(errors[0])[0]);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSave}
    >
      {({ isSubmitting }) => (
        <Form>
          <Card
            className={cn(styles.card)}
            title="Create Role"
            classTitle="title-red"
            head={
              <div className={styles.flex_box}>
                <button
                  className={cn("button-stroke")}
                  onClick={() =>
                    navigate("/settingsDashboard/accessControl/roles")
                  }
                >
                  <Icon name="arrow-left" size="24" />
                  <span>Back</span>
                </button>
              </div>
            }
          >
            <div className={styles.description}>
              <Field name="name">
                {({ field, meta }) => (
                  <TextInput
                    {...field}
                    label="Role Name"
                    tooltip="Maximum 50 characters."
                    className={styles.field}
                    error={meta.touched && meta.error ? meta.error : ""}
                    required
                  />
                )}
              </Field>
            </div>
          </Card>
          <div className="fixed bottom-7 left-30 right-5">
            <Panel />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default CreateRole;
